/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-floor.vue?vue&type=template&id=dd3aac90&scoped=true"
import script from "./pc-floor.vue?vue&type=script&lang=js"
export * from "./pc-floor.vue?vue&type=script&lang=js"
import style0 from "./pc-floor.vue?vue&type=style&index=0&id=dd3aac90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3aac90",
  null
  
)

export default component.exports